
import ModernTabs from '../../../common/Tabs/ModernTabs'
import Overview from './tabs/Overview';
import PatientAppointments from './tabs/PatientAppointments';
import PatientCommunicationPreferenceCard from './tabs/PatientCommunicationPreferenceCard';
function PatientTabs({patient}) {

   const TabContent = [
  {
    id: 'Overview',
    label: 'Patient Info',
    icon: 'bi-person-vcard', // Represents patient profile/info
    content: <Overview patient={patient} />
  },
  {
    id: 'Appointments',
    label: 'Appointments',
    icon: 'bi-calendar-check', // Represents calendar/scheduled appointments
    content: <PatientAppointments patient={patient} />
  },
  {
    id: 'comm-pref',
    label: 'Communication Preference',
    icon: 'bi-chat-square-text', // Represents chat or communication settings
    content: <PatientCommunicationPreferenceCard/>
  },
  {
    id: 'activity',
    label: 'Activity',
    icon: 'bi-activity', // Represents logs or ongoing activities
    content: <></>
  },
  {
    id: 'invalid-info',
    label: 'Invalid Info',
    icon: 'bi-exclamation-triangle', // Represents warning or invalid data
    content: ""
  },
  {
    id: 'activity',
    label: 'Activity',
    icon: 'bi-activity', // Represents activity or history
    content: ""
  },
];

  return (
    <>
        <ModernTabs orientation='vertical' tabs={TabContent} />
    </>
  )
}

export default PatientTabs